export default __webpack_public_path__ + "static/media/smart-helmet.b9196d1f.jpg";